import { IPosLayoutIn } from "../../models/input/agendaApi/IPosLayoutIn";
import * as ApiWithToken from "../callApiWithToken";

const posLayoutService = {
    getPosLayoutTypeByCategories: async function (languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `PosLayout/getPosLayoutTypeByCategories?languageId=${languageId}`);
    },
    insertPosLayout(posLayoutIn: IPosLayoutIn[]) {
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `PosLayout/insertPosLayout`, posLayoutIn);
    }
}

export default posLayoutService;